<div class="page-background">
    <div class="user-details-container container">
        <div class="logo-container">
            <img [src]="logoUrl" alt="logo" class="logo" />
        </div>

        <div class="form-container">
            <div class="form-header">
                <h3 class="heading">Almost There! 🧸</h3>
                <p class="message">
                    Help us deliver the fun to your doorstep! You can add your details now or skip and do it later
                    during checkout.
                </p>
            </div>

            <app-user-details-form></app-user-details-form>

            <div class="form-footer">
                <div class="text-icon-wrapper">
                    <mat-icon svgIcon="shield_half" class="footer-icon"></mat-icon>
                    <p>You can add or edit this later from profile or checkout</p>
                </div>
            </div>
        </div>
    </div>

    <div class="background-boxes">
        <span class="bg-box box-1"></span>
        <span class="bg-box frame-1"></span>
        <span class="bg-box box-2"></span>
        <span class="bg-box box-3"></span>
        <span class="bg-box box-4"></span>
        <span class="bg-box box-5"></span>
        <span class="bg-box box-6"></span>
        <span class="bg-box box-7"></span>
        <span class="bg-box box-8"></span>
        <span class="bg-box box-9"></span>
    </div>
</div>
